(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milad-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ft-product-details-layout')) {
    customElements.define('ft-product-details-layout', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-desktop-under-guarantee') || this.desktopQuery) return;
        this.details = this.querySelector('.ft-product-details');
        this.homeSection = this.closest('.section-product-details');
        if (!this.details || !this.homeSection) return;
        this.desktopQuery = window.matchMedia('(min-width: 768px)');
        this.handleLayoutChange = () => this.updatePosition();
        this.handleSectionUnload = (event) => {
          if (event.target.contains(this.details) && !event.target.contains(this)) {
            this.restorePosition();
          }
        };
        this.handleSectionSelect = (event) => {
          if (event.target === this.homeSection) {
            this.details.scrollIntoView({ block: 'nearest' });
          }
        };
        this.desktopQuery.addEventListener('change', this.handleLayoutChange);
        document.addEventListener('shopify:section:load', this.handleLayoutChange);
        document.addEventListener('shopify:section:unload', this.handleSectionUnload);
        document.addEventListener('shopify:section:select', this.handleSectionSelect);
        this.updatePosition();
      }

      disconnectedCallback() {
        if (!this.desktopQuery) return;
        this.desktopQuery.removeEventListener('change', this.handleLayoutChange);
        document.removeEventListener('shopify:section:load', this.handleLayoutChange);
        document.removeEventListener('shopify:section:unload', this.handleSectionUnload);
        document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        this.restorePosition();
        this.desktopQuery = null;
      }

      restorePosition() {
        if (this.details.parentElement !== this) this.append(this.details);
        this.details.classList.remove('ft-product-details--in-product-info');
        this.homeSection.classList.remove('ft-product-details-relocated');
      }

      updatePosition() {
        const guarantee = document.querySelector('.section-main-product > product-form.js-product .payment-guarantee');
        if (!this.desktopQuery.matches || !guarantee) {
          this.restorePosition();
          return;
        }
        if (guarantee.nextElementSibling !== this.details) {
          guarantee.insertAdjacentElement('afterend', this.details);
        }
        this.details.classList.add('ft-product-details--in-product-info');
        this.homeSection.classList.add('ft-product-details-relocated');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
